import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from '../../pa_checklist_followup.module.scss';

function ImageWithModal({ src, i }) {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <div
        key={`dir_img__${i}`}
        onClick={openModal}
        style={{ cursor: 'pointer', display: 'inline-block' }}
        className={styles.img_wrapper}
      >
        <img src={src} width="100%" alt={`img-${i}`} />
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        size="lg"
        backdropClassName={styles.backdrop_z_override}
      >
        <Modal.Body style={{ padding: 0 }}>
          <img
            src={src}
            alt={`large-img-${i}`}
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ImageWithModal;
